import { render } from "./WorkflowDetail.vue?vue&type=template&id=4246a953&scoped=true"
import script from "./WorkflowDetail.vue?vue&type=script&lang=js"
export * from "./WorkflowDetail.vue?vue&type=script&lang=js"

import "./WorkflowDetail.vue?vue&type=style&index=0&id=4246a953&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4246a953"]])

export default __exports__